(function () {
  const objectifs = {
    energie: {
      label: "Énergie & endurance",
      texte: "Votre profil suggère un besoin orienté vers l’énergie durable, la résistance à l’effort et la capacité à tenir dans le temps.",
      articles: [
        { label: "Triathlon : le secret naturel pour durer plus longtemps", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/triathlon-le-secret-naturel-pour-durer-plus-longtemps" },
        { label: "Épuisement fréquent ? Optimisez l’apport en oxygène et nutriments", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/fatigue-persistante-optimisez-naturellement-votre-apport-en-oxygene-et-en-nutriments" }
      ]
    },

    endurance: {
      label: "Endurance",
      texte: "Votre priorité semble être de soutenir une meilleure endurance, avec un accompagnement plus global de la résistance physique.",
      articles: [
        { label: "Trail et marathon : le secret des sportifs de haute altitude", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/trail-et-marathon-le-secret-des-sportifs-de-haute-altitude" },
        { label: "Récupération, énergie, endurance : le combo des sportifs d’hiver", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/recuperation-energie-endurance-le-combo-des-sportifs-d-hiver" }
      ]
    },

    recuperation: {
      label: "Récupération musculaire",
      texte: "Votre profil met surtout en avant un besoin de récupération plus efficace après l’effort et entre les séances.",
      articles: [
        { label: "Comment mieux récupérer après un combat de MMA", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/comment-mieux-recuperer-apres-un-combat-de-mma" },
        { label: "Récupération musculaire après l’effort : comment optimiser naturellement avec le Shilajit", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-favoriser-une-recuperation-optimale-selon-la-science" }
      ]
    },

    fatigue: {
      label: "Réduction de la fatigue",
      texte: "Vos choix évoquent surtout un besoin de mieux gérer la fatigue physique, la baisse de tonus et l’usure liée à l’effort.",
      articles: [
        { label: "Comment éviter la fatigue chronique chez les gymnastes", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/comment-eviter-la-fatigue-chronique-chez-les-gymnastes" },
        { label: "Fatigue liée à l’âge : comment retrouver énergie et vitalité après 40 ans ?", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-retrouver-energie-et-vitalite-apres-40-ans" }
      ]
    },

    focus: {
      label: "Concentration & focus",
      texte: "Votre priorité semble être de mieux soutenir l’attention, la vigilance et la prise de décision pendant l’effort.",
      articles: [
        { label: "Concentration et vigilance chez les pilotes : soutien naturel du focus mental", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/plus-de-concentration-grace-au-shilajit-comme-atout-naturel-pour-pilotes" },
        { label: "Concentration mentale : causes de la perte d’attention et solutions naturelles", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/concentration-mentale-causes-de-la-perte-dattention-et-solutions-naturelles" }
      ]
    },

    concentration: {
      label: "Clarté mentale",
      texte: "Votre sélection met en avant un besoin de clarté mentale, de vigilance et d’efficacité cognitive dans un contexte sportif.",
      articles: [
        { label: "Dirt jump : améliorer le focus et la prise de décision à l’effort", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/dirt-jump-ameliorer-le-focus-et-la-prise-de-decision-a-l-effort" },
        { label: "Mémoire et fonctions cognitives : soutenir naturellement la santé du cerveau avec le Shilajit", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/memoire-et-fonctions-cognitives-soutenir-naturellement-la-sante-du-cerveau" }
      ]
    },

    stress: {
      label: "Résistance au stress physique",
      texte: "Votre profil évoque un besoin de mieux encaisser la pression physique et mentale liée à l’entraînement ou à la performance.",
      articles: [
        { label: "Endurance et récupération dans l’entraînement Bootcamp", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/endurance-et-recuperation-dans-l-entrainement-bootcamp" },
        { label: "Stress et pression sociale : comment les réduire naturellement avec le Shilajit", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-reduire-le-stress-naturellement" }
      ]
    },

    sommeil: {
      label: "Sommeil & récupération nocturne",
      texte: "Vos réponses suggèrent qu’un meilleur sommeil pourrait soutenir plus efficacement votre récupération et votre régularité sportive.",
      articles: [
        { label: "Pilates : un complément naturel pour la récupération", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/pilates-un-complement-naturel-pour-la-recuperation" },
        { label: "Troubles du sommeil : peut-on retrouver un repos réparateur grâce au Shilajit ?", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/troubles-du-sommeil-comment-retrouver-un-repos-reparateur-naturellement" }
      ]
    },

    articulations: {
      label: "Soutien articulaire",
      texte: "Votre priorité semble être de préserver la mobilité, le confort articulaire et une meilleure récupération des tissus.",
      articles: [
        { label: "Escalade : force et récupération grâce à un complément naturel", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/escalade-force-et-recuperation-grace-a-un-complement-naturel" },
        { label: "Soulager ses articulations naturellement : les limites des formules industrielles et l’alternative du Shilajit", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle/alternative-naturelle-aux-complements-industriels-pour-articulation" }
      ]
    },

    poids: {
      label: "Gestion du poids",
      texte: "Votre sélection suggère un objectif de gestion du poids associé à l’endurance, à l’énergie et à de meilleures habitudes globales.",
      articles: [
        { label: "Le Shilajit pour la perte de poids : comment cela fonctionne-t-il ?", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/le-shilajit-pour-la-perte-de-poids-comment-cela-fonctionne-t-il" },
        { label: "Brûleurs de graisse chimiques : pourquoi le Shilajit apparaît comme une alternative naturelle plus durable", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle/perte-de-poids-naturelle-pourquoi-eviter-les-bruleurs-de-graisse-chimiques" }
      ]
    },

    hormonal: {
      label: "Vitalité hormonale",
      texte: "Vos choix évoquent surtout une recherche de vitalité, de puissance naturelle et de soutien hormonal global.",
      articles: [
        { label: "Testostérone et puissance en powerlifting : soutien naturel de la performance", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/testosterone-et-puissance-en-powerlifting-soutien-naturel-de-la-performance" },
        { label: "Testostérone basse : comprendre la fatigue persistante et relancer naturellement l’énergie masculine", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/testosterone-en-berne-comment-relancer-naturellement-votre-energie" }
      ]
    },

    force: {
      label: "Puissance & résistance musculaire",
      texte: "Votre profil met l’accent sur la force, la résistance musculaire et une meilleure capacité à soutenir l’effort intense.",
      articles: [
        { label: "Récupération et énergie : le soutien naturel du footballeur", url: "https://pureshilajithimalaya.fr/blogs/le-sport-et-le-shilajit-le-secret-des-sherpas/recuperation-et-energie-le-soutien-naturel-du-footballeur" },
        { label: "Dites adieu aux protéines en poudre ultra-transformées ! Comment construire du muscle naturellement ?", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle/dites-adieu-aux-proteines-en-poudre-ultra-transformees-comment-construire-du-muscle-naturellement" }
      ]
    },

    mineraux: {
      label: "Équilibre minéral",
      texte: "Votre sélection suggère qu’un soutien minéral plus large pourrait être pertinent pour l’énergie, la récupération et la constance à l’effort.",
      articles: [
        { label: "Le rôle du Shilajit sur la régénération cellulaire", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/pourquoi-votre-corps-perd-il-en-tonus" },
        { label: "Acides fulviques : bienfaits, rôle et effets selon la science", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/shilajit-et-acides-fulviques-pourquoi-sont-ils-si-puissants-pour-la-sante" }
      ]
    }
  };

  function initSportGuide() {
    const guides = document.querySelectorAll(".psh-sport-guide");

    if (!guides.length) return;

    guides.forEach(function (guide) {
      if (guide.dataset.initialized === "true") return;
      guide.dataset.initialized = "true";

      const button = guide.querySelector(".psh-bilan-btn");
      const resultats = guide.querySelector(".psh-sport-guide-resultats");

      if (!button || !resultats) return;

      button.addEventListener("click", function () {
        const scores = {};

        Object.keys(objectifs).forEach(function (key) {
          scores[key] = 0;
        });

        const checkedInputs = guide.querySelectorAll("input[type='checkbox']:checked");

        checkedInputs.forEach(function (input) {
          const list = input.getAttribute("data-objectifs");
          if (!list) return;

          list.split(",").forEach(function (objectif) {
            objectif = objectif.trim();

            if (scores[objectif] !== undefined) {
              scores[objectif]++;
            }
          });
        });

        const top = Object.entries(scores)
          .filter(function (entry) {
            return entry[1] > 0;
          })
          .sort(function (a, b) {
            return b[1] - a[1];
          })
          .slice(0, 3);

        if (!top.length) {
          resultats.innerHTML = "<p>Veuillez cocher au moins un objectif pour afficher vos recommandations.</p>";
          return;
        }

        let html = "<h3>Vos priorités sportives semblent être :</h3>";

        top.forEach(function (entry) {
          const key = entry[0];
          const item = objectifs[key];

          const articlesHtml = item.articles.map(function (article) {
            return `<a href="${article.url}">${article.label}</a>`;
          }).join("");

          html += `
            <div class="psh-result-card">
              <h3>${item.label}</h3>
              <p>${item.texte}</p>
              <div class="psh-related-title">Articles recommandés :</div>
              <div class="psh-related-links">
                ${articlesHtml}
              </div>
            </div>
          `;
        });

        resultats.innerHTML = html;
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSportGuide);
  } else {
    initSportGuide();
  }
})();